import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'umi';
import Checkboxbars from '@intelligence/components/GenreSelect/components/Checkboxbars';

import type { IBaseProps } from '@intelligence/components/GenreSelect/types';
import type { ICheckboxbarsProps } from '@intelligence/components/GenreSelect/components/Checkboxbars';

import '@intelligence/components/GenreSelect/components/CheckboxbarPanel/index.scss';

/**
 * 批量操作按钮状态（Select All/Clear All）
 * -1 不展示批量操作按钮
 * 0 展示Clear All按钮
 * 1 展示Select All按钮
 */
export type IBatchOperation = -1 | 0 | 1;

interface ICheckboxbarPanelProps extends IBaseProps, ICheckboxbarsProps {
  level: number;
  title?: string;
  header?: React.ReactElement;
  batchOperation?: IBatchOperation;
  onOperation?: (payload: boolean) => void;
}

const CheckboxbarPanel: React.FC<ICheckboxbarPanelProps> = (props) => {
  const {
    style,
    className,
    level,
    checkboxListClassName,
    containerRef,
    title,
    header,
    showRightArrow,
    batchOperation = -1,
    active,
    indeterminate,
    genres,
    onChange,
    onClick,
    onOperation,
  } = props;

  const { formatMessage } = useIntl();

  const showSelectAll = batchOperation === 1;

  return (
    <div style={style} className={classnames('genre-select-panel-item', className)}>
      {React.isValidElement(header) && header}
      <div className="panel-topbar">
        <span className="panel-title">{title}</span>
        {batchOperation !== -1 && (
          <a
            className="panel-operation"
            onClick={(e) => {
              e.stopPropagation();
              // 展示Select All时，点击就是要全选，反之取消全选
              onOperation?.(showSelectAll);
            }}
          >
            {showSelectAll ? formatMessage({ id: `dbi_select_all` }) : formatMessage({ id: `dbi_clear_all` })}
          </a>
        )}
      </div>
      <Checkboxbars
        level={level}
        checkboxListClassName={checkboxListClassName}
        containerRef={containerRef}
        showRightArrow={showRightArrow}
        active={active}
        indeterminate={indeterminate}
        genres={genres}
        onChange={onChange}
        onClick={onClick}
      />
    </div>
  );
};

export default CheckboxbarPanel;
